import type {IInputPropsV5} from "../../../widgets/input/clicktoedit/InputUtils";
import {TextInputV5} from "./TextInputV5";

export const IPInputV5 = (props: IInputPropsV5) => {
	const {value, onBlur, onInput, onChange} = props;

	return (
		<div className="hbox field-input-container">
			<TextInputV5
				value={value}
				onInput={onInput}
				autoFocus={false}
				onBlur={onBlur}
				onChange={onChange}
			/>
		</div>
	);
};
